/**
* Three Col Image JS
* -----------------------------------------------------------------------------
*
* All the JS for the Three Col Image component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    loadPopup: function( popupId ) {
      $.magnificPopup.open( {
        callbacks: {
          open: function() {
            $( `${popupId} .slider` ).slick(
                {
                  dots: false,
                  arrows: true,
                  prevArrow: '<svg class=\'flex-none hover:cursor-pointer w-6 h-6 icon icon-chevron-left\'><use xlink:href=\'#icon-chevron-left\'></use></svg>',
                  nextArrow: '<svg class=\'flex-none w-6 h-6 hover:cursor-pointer icon icon-chevron-right\'><use xlink:href=\'#icon-chevron-right\'></use></svg>',
                  slidesToShow: 1,
                  centerMode: false,
                  infinite: true,
                },
            );
          },
          close: function() {
            $( `${popupId} .slider` ).slick( 'unslick' );
          },
        },
        items: {
          src: popupId,
        },
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
      }, 0 );
    },

    className: 'three-col-image',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;
      $( document ).on( 'click', '.js-init-slider-popup', function( e ) {
        e.preventDefault();
        const popupId = $( this ).data( 'modal' );
        console.log( popupId );
        if ( popupId !== '' ) {
          _this.loadPopup( popupId );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'three-col-image', COMPONENT );
} )( app );
